import { FETCH_NEWS, FETCH_NEWS_DETAILS, MY_BOOKED_NEWS } from '../actions';

export const newsData = (state = {}, action) => {
  switch (action.type) {
    case FETCH_NEWS:
      return action.payload;
    default:
      return state;
  }
};

export const newsDetails = (state = {}, action) => {
  switch (action.type) {
    case FETCH_NEWS_DETAILS:
      return action.payload;
    default:
      return state;
  }
};

export const bookedNews = (state = {}, action) => {
  switch (action.type) {
    case MY_BOOKED_NEWS:
      return action.payload;
    default:
      return state;
  }
};
